// extracted by mini-css-extract-plugin
module.exports = {"modalMainContainer":"ImageModal_modalMainContainer__MY4NZ","image":"ImageModal_image__2Kh9f"};